import { Link } from 'react-router-dom';

export default function DiscreetLoginLink() {
  return (
    <Link to="/login" className="discreet-admin-link">Admin</Link>
  );
}
